(function (_) {
    'use strict';
    _['ESHOP.KEY'] = 'Tienda';
    _['ESHOP.NO-CONTENT'] = 'Este módulo no tiene contenido.';
    _['ESHOP.NO-PRODUCTS'] = 'No hay ningún producto con el filtro actual.';
    _['PRODUCTS.PRODUCT.TOCART.CONFIRM'] = 'Añadir a cesta';
    
}(translations['es']));












// WEBPACK FOOTER //
// ./src/app/modules/eshop/lang/eshop-lang_es.js